import React from "react";

// react-bootstrap components
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Pagination,
  Container,
  Row,
  Col,
} from "react-bootstrap";

function AdminFooter() {
  return (
    <>
      <footer className="footer">
        <Container fluid className="pl-4 ml-2">
          <nav>
            <ul className="footer-menu">
              <li>
                <a href="https://chungtai.org.au/" target="_blank" rel="noopener noreferrer">
                  官方網站
                </a>
              </li>
             
            </ul>
            <p className="copyright text-center">
              © {new Date().getFullYear()}{" "}
              <a href="https://chungtai.org.au/">寶林禪寺 Bao Lin Chan Monastery</a>
            </p>

          </nav>
        </Container>
      </footer>
    </>
  );
}

export default AdminFooter;
